import { render } from "./MSidebarFeatureGroup.vue?vue&type=template&id=5b6dcab1&scoped=true"
import script from "./MSidebarFeatureGroup.vue?vue&type=script&lang=js"
export * from "./MSidebarFeatureGroup.vue?vue&type=script&lang=js"

import "./MSidebarFeatureGroup.vue?vue&type=style&index=0&id=5b6dcab1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6dcab1"]])

export default __exports__